<template>
    <div class="CanvasPage"></div>
</template>

<script>
    export default {
        name: 'CanvasPage',
        props: {
            id: { required: true, type: String },
            page: { required: true, type: Number },
            canvas: { required: true, type: Element }
        },
        mounted: function () {
            this.canvas.setAttribute(this.$options._scopeId, "");
            this.$el.appendChild(this.canvas);
            //            this.$el = this.canvas;
            //            this.canvas.classList.add('pdfPage');
            //            this.canvas.classList.add('page-' + this.page);
        },
    };
</script>

<style scoped>
    .CanvasPage {
        width: 100%;
        height: 100%;
    }

    canvas {
        max-height: 100%;
        max-width: 100%;
        position: relative;
    }
</style>